import axios from "axios"
import { baseURL, config, requestID } from "../../common/utils"
import { Job } from "../../../models/Job"
// import axios from 'axios';
// import { Job } from '../models/Job';

export const getFilterApplicants = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }

    try {
        const res = axios.post(`${baseURL}jobs/filterApplications`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}

export const processApplicants = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }

    try {
        const res = axios.post(`${baseURL}jobs/processApplicants`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const getApplicantByTitle = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }
    try {
        const res = await axios.post(`${baseURL}jobs/getApplicantByTitle`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const getApplicantByBusiness = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }
    try {
        const res =await  axios.post(`${baseURL}jobs/getApplicantByBusiness`, payload, config)
        return res.data
    } catch (error) {
        console.error(error)
    }
}




export const createJobsQuestion = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }

    console.log({payload})

    try {
        const res = axios.post(`${baseURL}jobs/createJobQuestion`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}
export const deleteJobQuestion = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }

    console.log({payload})

    try {
        const res = axios.post(`${baseURL}jobs/deleteJobQuestion`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}


export const getJobsQuestion = async (data) => {

    const payload = {
        requestID: requestID(),...data
    }

    console.log({payload})

    try {
        const res = axios.post(`${baseURL}jobs/getJobQuestions`, payload, config)
        console.log(res)
        return res
    } catch (error) {
        console.error(error)
    }
}


export const fetchJobs = async (): Promise<Job[]> => {
    const payload = {
        requestID: requestID()
    }
  try {
    const res = await axios.post(`${baseURL}jobs/getAllJobs`, payload, config)
    return res.data.data;
  } catch (error) {
    console.error('Error fetching jobs:', error);
    return [];
  }
};
export const getAllCompanyJobs = async (data): Promise<Job[]> => {
    const payload = {
        requestID: requestID(),...data
    }
  try {
    const res = await axios.post(`${baseURL}jobs/getAllCompanyJobs`, payload, config)
    return res.data;
  } catch (error) {
    console.error('Error fetching jobs:', error);
    return [];
  }
};




export const fetchJobById = async (data) => {

     const payload = {
        requestID: requestID(),...data
    }
  try {
    const response = await axios.post(`${baseURL}jobs/getJob`, payload, config)
    console.log({response})
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};